const NAME = "ADVANCES_SETTINGS";

export default NAME;
